import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { BigCard, Tabela, Header } from '@equipedigitalfloripa/ed-cms/components'
import * as arquivosApi from '../api/arquivos'
import { fetchItems } from '../api/categoriaArquivos'
import { useSelector } from 'react-redux'

const Arquivos = () => {
  const translations = useSelector(state => state.translations.translations)
  const arquivosTranslations = translations['system-arquivos']
  const [categorias, setCategorias] = useState({})

  useEffect(() => {
    fetchItems().then(res => {
      let categoriasOptions = {}
      res.data.map(categoria => {
        categoriasOptions[categoria._id] = categoria.title
      })
      setCategorias(categoriasOptions)
    })
  }, [])

  const columns = [
    {
      title: "Nome",
      field: "title",
      sorting: true
    },
    {
      title: "Categoria",
      field: "category",
      center: true,
      sorting: categorias,
      render: rowData => {return (rowData.category != undefined) ? rowData.category.title : "unset"}
    },
    {
      title: "Nome",
      field: "titulo",
      sorting: false,
      center: true,
      render: rowData => 
        <><button style={{zIndex: 9999, position: "static", backgroundColor: "#0586D7", color: "white", borderRadius: 5, border: "none", padding: 3}} type='submit' onClick={() => {
        navigator.clipboard.writeText(`${process.env.REACT_APP_API_URL}arquivos/${rowData._id}/file`)
        alert("Link copiado!")
      }}> Copiar link de download</button></>
    },
  ];

  // const options = {
  //   filtering: true,
  //   actionsColumnIndex: -1,
  //   paging: false
  // }

  return (
    <React.Fragment>
      <Header title={"Arquivos"} subtitle={"Lista de arquivos"}>
        <i className="fas fa-coins awesome-header"></i>
      </Header>
      <Container className="page-content">
        <BigCard>
          <Tabela
            url={'arquivos'}
            columns={columns}
            fetchFunction={arquivosApi.fetchItems}
            removeFunction={arquivosApi.removeItem}
            statusFunction={arquivosApi.statusItem}
            enableSearch
          />
        </BigCard>
      </Container>
    </React.Fragment>
  )
}

export default Arquivos
